import { PauseIcon, PlayIcon } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
export function MaterialPreviewSection() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const isUserPausedRef = useRef(false);
  const [isPaused, setIsPaused] = useState(false);
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !isUserPausedRef.current) {
        void video.play().catch(() => undefined);
      } else if (!entry.isIntersecting) {
        video.pause();
      }
    }, {
      threshold: 0.45
    });
    observer.observe(video);
    return () => observer.disconnect();
  }, []);
  const togglePlayback = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      isUserPausedRef.current = false;
      setIsPaused(false);
      void video.play().catch(() => undefined);
      return;
    }
    isUserPausedRef.current = true;
    video.pause();
    setIsPaused(true);
  };
  return <section className="border-t border-white bg-[#F4F7FA] px-5 py-16 sm:px-8 md:py-24" aria-labelledby="material-preview-title" style={{
    paddingTop: "0px",
    paddingBottom: "33px"
  }} data-id="element-82" data-mp="2hza97g0u0mou">
      <div className="mx-auto max-w-4xl text-center" data-id="element-83" data-mp="2qwuceui98t23">
        <span className="inline-flex items-center gap-2 text-[10px] font-black tracking-[0.16em] text-emerald-700" data-id="element-84" data-mp="2vpdn9jpk5a37">
          <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" aria-hidden="true" data-id="element-85" data-mp="30mvrwxwjl35e" />
          MATERIAL POR DENTRO
        </span>
        <h2 id="material-preview-title" className="mx-auto mt-5 max-w-3xl text-3xl font-black leading-[0.98] tracking-[-0.04em] text-[#0B1F3B] sm:text-5xl" data-id="element-86" data-mp="35p4m1xl5ib93">
          MIRÁ LAS INSTALACIONES QUE VAS A TENER A MANO
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-slate-600 sm:text-base" data-id="element-87" data-mp="1g83l30carkp1">
          Conocé las láminas reales, sus diagramas, explicaciones y puntos de verificación.
        </p>

        <div className="relative mx-auto mt-10 w-[calc(100%-8px)] max-w-[360px] overflow-hidden rounded-2xl bg-white sm:mt-12" data-id="element-88" data-mp="2nkcn58cq0duk">
          <video ref={videoRef} className="block h-auto w-full origin-center scale-[1.05]" src="https://cdn.magicpatterns.com/uploads/oBYhq1GPatCKVfDdXdyjPv/1024(1).mp4" autoPlay muted loop playsInline aria-label="Vista previa en video de +100 Instalaciones Eléctricas Resueltas" data-id="element-89" data-mp="2imjk2o6przyi" />
          <button type="button" onClick={togglePlayback} className="absolute bottom-3 right-3 inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#0B1F3B]/85 text-white shadow-sm transition-[background-color,transform] duration-150 hover:bg-[#0B1F3B] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#F5C844]" aria-label={isPaused ? 'Reanudar video' : 'Pausar video'} data-id="element-90" data-mp="36ix9yo7kwx2e">
            {isPaused ? <PlayIcon className="h-4 w-4" aria-hidden="true" data-id="element-91" data-mp="3p96p0yogsjbi" /> : <PauseIcon className="h-4 w-4" aria-hidden="true" data-id="element-92" data-mp="3p7vn74ekxln1" />}
          </button>
        </div>
      </div>
    </section>;
}